<template>
  <div v-show="withdrawGuidePop.isShow" class="withdraw-guide-pop" @click.stop>
    <section class="pop-content1">
      <div class="g-close" @click="hidePop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <div>
        <h2>企鹅小店提现指引</h2>
        <div class="qrcode-wrap">
          <img class="qrcode" src="../../assets/wdzg-qrcode-app.jpg" alt>
        </div>
        <div class="tip">
          <p>
            扫描二维码下载APP-我的钱包—提现—选择开户行、填写银行卡号—点击“提现”—申请成功。
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'WithdrawGuidePop',
  data() {
    return {};
  },
  computed: {
    ...mapState({
      withdrawGuidePop: state => state.common.withdrawGuidePop,
    }),
  },
  mounted() {},
  methods: {
    hidePop() {
      this.$store.commit('common/HIDE_WITHDRAW_GUIDE_POP');
    },
  },
};
</script>

<style lang="less" scoped>
@popH: 500px;
@popHeaderH: 100px;
@popFooterH: 80px;

.withdraw-guide-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(33, 33, 33, 0.6);
  .g-close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    img {
      cursor: pointer;
    }
  }
  .pop-content {
    position: relative;
    width: 800px;
    height: @popH;
    background-color: #fff;
    border-radius: 4px;
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: @popHeaderH;
      .title {
        margin-bottom: 10px;
      }
    }
    .inner-content {
      height: calc(@popH - @popHeaderH - @popFooterH);
      display: flex;
      justify-content: center;
      background-color: rgb(239, 239, 239);
      .guide-item {
        padding: 20px 10px;
        text-align: center;
        flex: 1;
        .tip {
          margin-bottom: 10px;
          padding: 0 40px;
        }
      }
      .guide-item1 {
        display: flex;
        justify-content: center;
        align-items: center;
        .tip {
          margin-top: 20px;
          .em {
            color: var(--ui-main-color);
          }
        }
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: @popFooterH;
    }
  }
  .pop-content1 {
    position: relative;
    width: 400px;
    height: 500px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .qrcode-wrap {
      width: 180px;
      height: 180px;
      margin: 0 auto;
      margin-top: 50px;
      border: 1px solid #e2e2e2;
      border-radius: 4px;
      padding: 8px;
      text-align: center;
      .qrcode {
        width: 100%;
        height: 100%;
      }
    }

    .tip,
    .err-tip {
      margin-top: 20px;
      padding: 0 50px;
    }
    .err-tip {
      color: #f6786e;
    }
    .panel-wrap {
      margin-top: 30px;
    }
  }
}
</style>
